import { render, staticRenderFns } from "./Oportunidades.vue?vue&type=template&id=51dde96a&scoped=true"
import script from "./Oportunidades.vue?vue&type=script&lang=js"
export * from "./Oportunidades.vue?vue&type=script&lang=js"
import style0 from "./Oportunidades.vue?vue&type=style&index=0&id=51dde96a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dde96a",
  null
  
)

export default component.exports